import BaseService from "../../../../services/BaseService";
import { buildThreePath } from "../../../../helpers";
import i18n from "i18next";
import moment from "moment";


function getInitialValues(attributes, attributesValues) {
    const valuesIds = attributesValues && attributesValues.map(el => el.paramId);

    const attributesToInit = attributes.filter(el => valuesIds.includes(el.id));

    const initObj = {};

    attributesToInit.forEach(field => {
        const fieldName = field.code;
        if (field.type === "THREE") {
            // const prevData = initObj[fieldName] || [];
            // console.log({field, prevData, fieldName, attributesValues});
            const foundValues = attributesValues.filter(elem => elem.paramId === field.id);
            initObj[fieldName] = foundValues.map(value => ({ ...value, id: value.value, key: value.value, name: value.label }));

            // initObj[fieldName] = [
            //     ...prevData,
            //     { id: field.value, key: field.value, label: field.label, value: field.value, path: "" },
            // ];

            // const options = buildThreePath(field.dict, false, { children: "children" });
            // if (attributesValues.length) {
            //     const currentAppealType = [];
            //     attributesValues.map(i => {
            //         const item = searchTree(options, "children", result => {
            //             return i.value === result.key;
            //         });

            //         if (item) {
            //             currentAppealType.push({
            //                 value: item.key,
            //                 label: item.name,
            //                 path: item.path,
            //             });
            //         }
            //     });

            //     if (currentAppealType) {
            //         initObj[fieldName] = currentAppealType;
            //     }
            // }
        } else if (field.type === "DATE") {
            const foundValues = attributesValues.filter(elem => elem.paramId === field.id);
            if (field.def_condition === "EQU" && foundValues.length > 0) {
                const momentDate = moment(foundValues[0].value);
                const timezoneOffset = momentDate.utcOffset();
                const tsWithoutTimezoneOffset = (momentDate.unix() * 1000) - (timezoneOffset * 60000);
                initObj[fieldName] = tsWithoutTimezoneOffset;
                // initObj[fieldName] = new Date(foundValues[0].value).getTime();  // old value with timestamp
            } else if (field.def_condition === "BTW" && foundValues.length > 0) {
                foundValues.forEach(date => {
                    const ending = date.conditionCode === "LEQ" ? "@TO" : "@FROM";
                    const momentDate = moment(date.value);
                    const timezoneOffset = momentDate.utcOffset();
                    const tsWithoutTimezoneOffset = (momentDate.unix() * 1000) - (timezoneOffset * 60000);
                    initObj[`${fieldName}${ending}`] = tsWithoutTimezoneOffset;
                    // initObj[`${fieldName}${ending}`] = new Date(date.value).getTime(); // old value with timestamp
                });
            }
        } else if (field.type === "LIST" && field.multiset_allowed === "Y") {
            const listValue = attributesValues.filter(elem => elem.paramId === field.id);
            // console.log({fieldName,listValue});
            // if (field.search && !field.dict_search) {
            //     initObj[fieldName] = listValue.map(el => {
            //         const option = field.dict.find(item => {
            //             return el.value === item.key;
            //         });
            //         return {
            //             value: option ? option.key : null,
            //             label: option ? option.value : "",
            //         };
            //     });
            // }

            if (field.dict_search) {
                initObj[fieldName] = listValue.map(el => {
                    return {
                        value: el.value,
                        label: el.label,
                    };
                });
            } else {
                initObj[fieldName] = listValue.map(el => el.value);
            }
        } else {
            initObj[fieldName] = attributesValues.filter(elem => elem.paramId === field.id)[0].value;
        }
    });
    return initObj;
}

function getWidgetType(type, search, dictSearch, isMulti) {
    let listWidget = "select";
    if (dictSearch) {
        listWidget = "ajaxCombo";
    }
    if (search || isMulti) {
        listWidget = "multiselect";
    }

    const components = {
        LIST: listWidget,
        NUMBER: "input",
        STRING: "input",
        DATE: "datetime",
        THREE: "selectTreeMultiModalWithSearch",
    };

    return components[type] || "input";
}

function convertFieldConfigToProps(fieldConfig) {
    // const disabled = !filter.newFilter ? true : (predefined && !filter.newFilter);
    const disabled = false;

    const multi = ["LIST", "THREE"].includes(fieldConfig.type) && fieldConfig.multiset_allowed === "Y";
    // let options = fieldConfig.type === 'THREE' ? { children: buildThreePath(fieldConfig.dict, false, { children: 'children' }) } : getOptions(fieldConfig.dict || []);

    const values =
        fieldConfig.type === "THREE"
            ? { children: buildThreePath(fieldConfig.dict, false, { children: "children" }) }
            : fieldConfig.dict; // getOptions(fieldConfig.dict || []);

    const widgetType = getWidgetType(fieldConfig.type, fieldConfig.search, fieldConfig.dict_search, multi);

    let config = {
        id: fieldConfig.id,
        key: fieldConfig.code,
        name: fieldConfig.code,
        title: fieldConfig.name,
        withSearch: fieldConfig.search,
        withAsyncSearch: fieldConfig.dict_search,
        widgetType,
        values,
        multi,
        disabled,
        tree: fieldConfig.type === "THREE",
        errorPlaceholder: true,
        valueField: fieldConfig.type === "THREE" ? "value" : "key",
        keySelectField: "key",
        leafField: fieldConfig.type === "THREE" ? "leaf" : "children",
        isHidden: fieldConfig.hidden,
        def_value: fieldConfig.def_value
    };

    if (widgetType === "multiselect") {
        config.savedValue = [];
        config.savedValues = [];
    }

    if (fieldConfig.type === "THREE") {
        config.options = values;
        config.selectedOptions = [];
        // config.nodeArray = values;
    }

    if (fieldConfig.dict_search) {
        const { disallow_select_all } = fieldConfig;

        config = {
            ...config,
            disallow_select_all,
            customAjaxOptions: (value, cb, key, values, widget) => {
                const data = {
                    search: value,
                    id: widget ? widget.id : fieldConfig.id,
                };
                BaseService.post("async_search_attributes", { data, jsonType: true })
                    .then(response => {
                        if (fieldConfig.type === "THREE") {
                            return cb(response.result);
                        }
                        cb(
                            response.result.map(field => ({
                                label: field.value || "",
                                value: field.id || "",
                            }))
                        );
                    })
                    .catch(e => {
                        console.error("SidebarFiltersForm::customAjaxOptions: ", e);
                    });
            },
        };

        if (fieldConfig.type === "THREE") {
            config.valueField = "key" // in static dict valueField is "value" (look on top)
        }
    }

    if (fieldConfig.def_condition === "BTW") {
        const fromDateConfig = {
            ...config,
            name: `${fieldConfig.code}@FROM`,
            title: `${fieldConfig.name} ${i18n.t("filters.from")}:`,
            key: `${fieldConfig.code}@FROM`,
            maxDateKey: `${fieldConfig.code}@TO`,
        };
        const toDateConfig = {
            ...config,
            name: `${fieldConfig.code}@TO`,
            title: `${fieldConfig.name} ${i18n.t("filters.to")}:`,
            key: `${fieldConfig.code}@TO`,
            minDateKey: `${fieldConfig.code}@FROM`,
        };
        return [fromDateConfig, toDateConfig];

        // const isFrom = fieldConfig.code.includes("_BEGIN_");
        // if (isFrom) {
        //     config = {
        //         ...config,
        //         maxDateKey: fieldConfig.code.replace("_BEGIN_", "_END_"),
        //     };
        // } else {
        //     config = {
        //         ...config,
        //         minDateKey: fieldConfig.code.replace("_END_", "_BEGIN_"),
        //     };
        // }
    }

    return config;
}

export function getDynamicFormSturcture(attributes, values, isFilterParams, view = "1column", additionalWidgets) {
    const initValues = getInitialValues(attributes, values);
    // flatMap is used to properly flatten the possible array of BTW dates inside of attributes
    const convertedAttributes = attributes.flatMap(convertFieldConfigToProps);
    let convertedAttributesWithValues = convertedAttributes.map(attr => ({
        ...attr,
        savedValue: initValues[attr.key] || attr.savedValue || attr.def_value,
        savedValues: initValues[attr.key] || attr.savedValues,
        disabled: isFilterParams,
    }));

    // provide some additional widgets on the top
    if (additionalWidgets && Array.isArray(additionalWidgets)) {
        convertedAttributesWithValues = [...additionalWidgets, ...convertedAttributesWithValues];
    }
    return [
        {
            view,
            collapsed: false,
            widgets: convertedAttributesWithValues,
        },
    ];
}
